<template>
  <div>
    <div v-if="isLoading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div class="d-flex flex-wrap row" v-if="conversations && conversations.length > 0">
      <div class="col-md-4 col-sm-12" v-for="conversation in conversations" :key="conversation.campaignCardKey || conversation.conversationId">
        <div class="our-team-main">
          <div>
            <div class="team-front">
              <div class="perfilInfos" @click="openAttachModalMessages(conversation.conversationId, conversation.provider, conversation.identifierProvider)">
                <img :src="getAvatar(conversation.photo)" />
                <div class="name" :title="getDisplayName(conversation)">
                  {{ getDisplayName(conversation) }}
                </div>
                <label for="Telefone">{{ conversation.formattedPhone ? 'Telefone: ' + conversation.formattedPhone : 'Usuário não possui telefone' }}</label>
                <label for="Data">{{ conversation.campaignSentAt ? 'Enviado em ' : 'Aberto em ' }}{{ formatDate(conversation.campaignSentAt || conversation.createdAt) }}</label>
                <div class="origem-container">
                  <label for="Origem" class="origemFormat">
                    <strong>Origem:</strong> {{ formatProviderPhoneNumber(conversation.identifierProvider) || ' ' }}
                  </label>
                  <div class="chat-conversations-identify-provider">
                    <img :src="`../../static/img/chat/providers/${conversation.provider}.png`" width="15px" alt="provider" />
                  </div>
                </div>

                <!-- <label for="GerenteRelacionamento">{{ conversation.personDetails.gerenteRelacionamento ? 'Gerente Relacionamento' + conversation.personDetails.gerenteRelacionamento : 'Nenhum' }}</label> -->

              </div>
              <div class="buttons-container">
                <defaultbutton
                :class="['defaultbutton col-12', larguraTela <= 576 ? 'btn-mobile' : '']"
                :onClick="() => openAttachModalMessages(conversation.conversationId)"
                btnVariant="btn-third"
                icon="fas fa-comments"
                :text="larguraTela > 576 ? 'mensagem' : null"
              />
                <defaultbutton
                  class="defaultbutton col-12"
                  :onClick="() => openAttachModal(conversation)"
                  btnVariant="btn-third"
                  icon="fas fa-arrow-right"
                  :text="larguraTela > 576 ? 'transferir' : null"
                />
                <defaultbutton
                  class="defaultbutton col-12"
                  :onClick="() => sendAssumeOperator(conversation)"
                  :disabled="isProcessing"
                  btnVariant="btn-third"
                  icon="fa fa-user-check"
                  :text="larguraTela > 576 ? 'assumir' : null"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MessagesModal ref="messagesModal" :btnRelatorio="true" />
    <b-modal centered ref="modal-new" v-model="showModalTransfer" title="Transferir">
      <label for="username-select">Selecione um usuário:</label>
      <b-form-select id="username-select" v-model="selectedUsername" :options="usernames"></b-form-select>
      <label style="margin-top:10px" for="observation">Observação:</label>
      <toogleswitch style="margin-top: 10px;" v-model="createObservation" label="Adicionar Observação" />
      <div v-show="createObservation">
        <div v-if="observationTranfer" style="margin-top: 10px;">
          <b-form-textarea
            id="observation"
            v-model="observationTranfer"
            placeholder="Observação"
            maxlength="90"
          />
          <small class="text-muted">{{ observationTranfer.length }}/90 caracteres</small>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-on:click="sendUpdateOperator(conversation)"
            v-b-tooltip.hover
            :title="'Transferir'"
          >
            <i class="fa fa-angle-double-right"></i>
            <span class="d-md-down-none"> Transferir</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ConversationsSearch from './ConversationsSearch.vue'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import toogleswitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import MessagesModal from '@/views/private/atendimento/components/modal/MessageModals.vue'

export default {
  name: 'Messages',
  components: {
    ConversationsSearch,
    defaultbutton,
    toogleswitch,
    MessagesModal
  },
  props: {
    conversations: {
      type: Array,
      required: true
    }
  },
  mixins: [AccountMixin],
  person: {
    type: Object,
    required: false,
    default: () => null
  },
  data () {
    return {
      isLoading: false,
      larguraTela: window.innerWidth,
      searchText: '',
      showModalTransfer: false,
      usernames: [],
      messages: [],
      showModalMessages: false,
      selectedUsername: null,
      selectedConversationId: null,
      observationTranfer: null,
      dialog: false,
      createObservation: false,
      gerenteRelacionamento: null,
      isProcessing: false
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.atualizarLargura)
  },
  computed: {
    filteredConversations () {
      return this.conversations.filter(conversation => {
        return (
          conversation.name.nome.toLowerCase().includes(this.searchText.toLowerCase()) ||
          conversation.conversationId.toString().toLowerCase().includes(this.searchText.toLowerCase()) ||
          conversation.identifier.toString().toLowerCase().includes(this.searchText.toLowerCase().replace(/\D/g, ''))
        )
      })
    }
  },
  watch: {
    isLoading (newValue) {
      this.$emit('loading-changed', newValue)
    },
    conversations: {
      handler () {
      },
      deep: true
    }
  },
  showWarning () {
    this.$bvToast.toast('Não é possível realizar esta ação pois está sendo atendida pelo bot.', {
      title: 'Atendimento sendo realizado pelo bot',
      variant: 'danger',
      solid: true
    })
  },
  created () {
    this.getUsernames()
    window.addEventListener('resize', this.atualizarLargura)
  },
  methods: {
    atualizarLargura () {
      this.larguraTela = window.innerWidth
    },
    getAvatar (encodedImage) {
      if (encodedImage) {
        return `data:image/png;base64,${encodedImage}`
      }

      return '/static/img/avatars/03.png'
    },
    getDisplayName (conversation) {
      let name = 'Usuário não possui nome'
      if (conversation.name && conversation.name.nome) {
        name = conversation.name.nome
      }
      return name
    },
    sendUpdateOperator (conversation) {
      const message = {
        conversationId: conversation.conversationId,
        username: this.selectedUsername.username,
        nameOperator: this.selectedUsername.nome.replace('\t', ''),
        identifier: conversation.identifier,
        name: conversation.name,
        provider: conversation.provider,
        event: 'transferir',
        protocol: conversation.protocol,
        deptoId: conversation.deptoId,
        description: this.observationTranfer,
        identifierProvider: conversation.identifierProvider
      }
      this.$emit('sendUpdateOperator', message)
      this.isLoading = true
    },
    async sendAssumeOperator (conversation) {
      this.isProcessing = true
      const message = {
        conversationId: conversation.conversationId,
        username: this.account.username,
        operatorId: this.account.id,
        nameOperator: this.account.pessoa.nome.replace('\t', ''),
        identifier: conversation.identifier,
        name: conversation.name,
        provider: conversation.provider,
        event: 'assumir',
        deptoId: conversation.deptoId,
        protocol: conversation.protocol,
        description: 'Atendimento assumido pelo operador',
        identifierProvider: conversation.identifierProvider
      }
      try {
        await this.$emit('sendAssumeOperator', message)
        this.isLoading = false
      } catch (error) {
        console.error(error)
      } finally {
        this.isProcessing = false
      }
    },
    openAttachModal (conversation) {
      this.conversation = conversation
      this.showModalTransfer = true
    },
    formatDocument (document) {
      if (!document) {
        return 'Usuário não possui documento'
      }

      let formattedDocument = document
      let documentType = ''

      if (document.length === 11) {
        formattedDocument = document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        documentType = 'CPF '
      } else if (document.length === 14) {
        formattedDocument = document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
        documentType = 'CNPJ '
      }

      return documentType + formattedDocument
    },
    formatProviderPhoneNumber (number) {
      if (!number) return null

      // Remove todos os caracteres não numéricos
      const cleaned = number.toString().replace(/\D/g, '')

      // Verifica se é um número válido com DDI, DDD e número
      const match = cleaned.match(/^(\d{2})(\d{2})(\d{5})(\d{4})$/)
      if (match) {
        return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`
      }
      return number
    },
    async getUsernames () {
      var requestConfig = {}
      if (this.account.administrador) {
        requestConfig = {
          permissions: [],
          paId: [],
          isAdm: this.account.administrador
        }
      } else {
        requestConfig = {
          permissions: this.account.permissoes,
          paId: this.account.funcionario.paId,
          isAdm: false
        }
      }
      try {
        const response = await AtendimentoRepository.GetUsenames(requestConfig)
        const { data } = response
        this.usernames = data.usernames.map(username => {
          return { text: username.nome, value: { username: username.username, nome: username.nome } }
        })
      } catch (error) {
        console.error(error)
      }
    },
    formatDate (date) {
      let d = new Date(date)
      return d.toLocaleDateString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    },
    openAttachModalMessages (conversationId, provider, identifierProvider) {
      this.$refs.messagesModal.openModal(conversationId, provider, identifierProvider)
    }
  }
}
</script>

<style lang="scss" scoped>

.container-fluid {
  height: 100%;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #0BACA0 transparent;
}

.our-team-main {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  padding: 10px;
  position: relative;
  margin: 10px;
  gap: 14px;
  transform: translateZ(0);
  backface-visibility: hidden;
  transition: transform 0.3s ease-in-out;
}

.our-team-main:hover {
  transform: scale(1.05);
}
.photo {
  padding: auto;
  width: 90%;
  height: 90%;
  text-align: left;
}
img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1px solid #01d6bd;
}
.perfilInfos {
  width: 100%;
  height: 100%;
  text-align: start;
}
.perfilInfos:hover {
  cursor: pointer;
}
.perfilInfos label {
  font-size: 12px;
  margin-bottom: -3px;
  font-weight: bold;
}
.buttons-container {
  display: flex;
  flex-wrap: wrap;
  margin-left: 1rem;
}
.defaultbutton {
    margin-bottom: 2px;
}
.team-front {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  max-width: 100%;
}
.name {
  font-size: 17px;
  font-weight: bold;
  color: #1BACA0;
  margin-top: 7px;
  width: 190px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.detailsConversation {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.detailsConversation label {
  font-size: 10px;
  color: #01d6bd;
  margin-bottom: -3px;
  font-weight: bold;
}
.modal-content {
  height: auto;
  width: 100%;
}
.modal-content {
    height: 400px;
    width: 100%;
  }
  .spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left: 4px solid #1BACA0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.origem-container{
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8.7px;
}

.origemFormat{
  font-family: 'Arial' !important;
  margin-bottom: 0.2rem;
}

.chat-conversations-identify-provider img{
  border: none;
  width: 14px;
  height: 14px;
  top: -4px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/central_atendimento_geral/components/conversations/Conversations.vue